import * as React from 'react';
import { AppBar } from 'react-admin';

const MyAppBar = props => (
    <AppBar
        {...props}
        color='primary'
    ></AppBar>
);

export default MyAppBar;
